import { Avatar, Box, Stack } from "@mui/material";
import { IconMapPin, IconUsers } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { GroupIcon } from "../../../components/icons";
import Text from "../../../components/ui/Text";
import { ROUTES } from "../../../constants/routes";
import { DESKTOP_LAYOUTS } from "../../../constants/spacing";
import { useToast } from "../../../contexts/ToastContext";
import apiService from "../../../services/api";

export const YourGroups = () => {
  const navigate = useNavigate();
  const { showToast } = useToast();

  const [userGroups, setUserGroups] = useState([]);
  const handleGroupClick = (groupId) => {
    navigate(ROUTES.VIEW_GROUP.replace(":groupId", groupId));
  };

  useEffect(() => {
    const getGroups = async () => {
      try {
        const response = await apiService.fetchUserGroups();
        if (response.success) {
          setUserGroups(response.data);
        }
      } catch (error) {
        showToast(error.error, "error");
      }
    };
    getGroups();
  }, []);

  return (
    <Box sx={DESKTOP_LAYOUTS.contentCard}>
      <Text variant="paragraph" sx={{ fontSize: "20px", mb: 3 }}>
        Your groups
      </Text>

      {userGroups.length > 0 ? (
        <Stack spacing={2} sx={{ mt: 2 }}>
          {userGroups.map((group) => (
            <Box
              component={Link}
              to={`/group/${group.id}`}
              key={group.id}
              onClick={() => handleGroupClick(group.id)}
              sx={{
                p: 2,
                border: "1px solid #E5E5E5",
                borderRadius: "8px",
                cursor: "pointer",
                "&:hover": {
                  backgroundColor: "#F9F9F9",
                },
                textDecoration: "none",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  mb: 2,
                }}
              >
                <Avatar
                  src={group?.avatar_image_url}
                  sx={{
                    width: 40,
                    height: 40,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "18px",
                  }}
                >
                  <GroupIcon width={32} height={32} />
                </Avatar>
                <Text variant="h6" sx={{ fontSize: "16px", fontWeight: 600 }}>
                  {group.name}
                </Text>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                  }}
                >
                  <IconMapPin size={16} color="#666" />
                  <Text variant="body2" sx={{ color: "#666" }}>
                    {`${group.city}, ${group.country}`}
                  </Text>
                </Box>
                <Box
                  sx={{
                    borderRadius: "50%",
                    backgroundColor: "#E5E5E5",
                    width: "8px",
                    height: "8px",
                  }}
                />
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                  }}
                >
                  <IconUsers size={16} color="#666" />
                  <Text variant="body2" sx={{ color: "#666" }}>
                    {group.active_players.length} Members
                  </Text>
                </Box>
              </Box>
            </Box>
          ))}
        </Stack>
      ) : (
        <Text
          variant="body2"
          sx={{ textAlign: "center", py: 2, color: "#666" }}
        >
          You're not a member of any groups yet. When you join a game you'll
          become a member.
        </Text>
      )}
    </Box>
  );
};
